<template>
  <div class="container-fluid mt-5">
    <div v-if="showError" class="text-center mt-5">
      <h3>{{ $t("NOTIFICATIONS.OBJECT_UNAVAILABLE") }}</h3>
      <p>{{ $t("NOTIFICATIONS.OBJECT_UNAVAILABLE_DESCRIPTION") }}</p>
      <router-link
        :to="{ name: 'List Notifications' }"
        class="btn btn-primary"
      >
        {{ $t("NOTIFICATIONS.BACK_TO_NOTIFICATIONS") }}
      </router-link>
    </div>
  </div>
</template>

<script>
import swal from "sweetalert2";

export default {
  layout: "DashboardLayout",

  components: {},

  mixins: [],

  data() {
    return {
      showError: false,
    };
  },

  computed: {},

  watch: {},

  created() {
    this.getNotification();
  },

  methods: {
    async getNotification() {
      swal.fire({
        allowEscapeKey: false,
        allowOutsideClick: false,
        onOpen: () => {
          swal.showLoading();
        },
      });
      try {
        await this.$store.dispatch("notifications/get", this.$route.params.id);
        const notification = this.$store.getters["notifications/notification"];

        if (notification.data.object_class === "App\\Models\\File") {
          this.$router
            .push({
              name: "Files Explorer",
              query: {
                file_id: notification.data.object_id,
                folder_id: notification.data.object_data?.folder_id,
              },
            })
            .catch(() => {});
          swal.close();
          return;
        }

        const route = this.$objectViewRoute({
          type: notification.data.object_type,
          id: notification.data.object_id,
        });

        if (route && route !== "/") {
          this.$router.push(route).catch(() => {});
        } else {
          this.showError = true;
        }
      } catch (error) {
        this.showError = true;
      }
      swal.close();
    },
  },
};
</script>
